export * from './src/accessibility-v1-accessibility-scan-accessibility-scans.universal.js';
